import { Component, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  imports: [
    TranslateDirective
  ],
  selector: 'td-wb-page-header-date',
  templateUrl: 'page-header-date.component.html',
  styleUrls: ['page-header-date.component.scss']
})
export class PageHeaderDateComponent {
  readonly date = input<string>(undefined);
}
